import ModalErrorBoundary from '@UI/modals/ModalErrorBoundary';
import SnapshotChangesModal from '@UI/modals/SnapshotChangesModal';
import type { RootState } from '@generalTypes/rootStateTypes';
// @ts-ignore shared component package has no published TS declarations
import { Modal } from '@kathondvla/react-shared-components/src/components';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

const SnapshotChangesButton: React.FC = () => {
  const snapshotChangesModalRef = useRef<Modal>();

  const selectedSnapshotVersion = useSelector(
    (state: RootState) => state.documentSnapshot?.selectedSnapshotVersion ?? null,
  );
  const isSnapshotContentFetched = useSelector(
    (state: RootState) => state.documentSnapshot?.isSnapshotContentFetched ?? false,
  );

  const isDisabled = !selectedSnapshotVersion || !isSnapshotContentFetched;

  const handleOpen = () => {
    if (isDisabled) {
      return;
    }
    snapshotChangesModalRef.current?.open({});
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-default buttonRelative"
        onClick={handleOpen}
        disabled={isDisabled}
      >
        <span
          className="glyphicon glyphicon-list-alt"
          style={{ marginRight: '5px', verticalAlign: 'top' }}
        />
        <span>Toon versiewijzigingen</span>
      </button>

      <Modal
        ref={snapshotChangesModalRef}
        size="lg"
        component={<SnapshotChangesModal />}
        errorBoundaryComponent={ModalErrorBoundary}
      />
    </>
  );
};

SnapshotChangesButton.displayName = 'SnapshotChangesButton';

export default SnapshotChangesButton;
